import {VATRate} from "../../models/common/vat-rate";
import {BusinessCaseType} from "../../_modules/location/_models/_enums/business-case-type";

/**
 * The VAT key a Kassendifferenz (`DifferenzSollIst`) is recorded under, decided by its direction (#822):
 * a surplus (more cash counted than expected) is recorded at the standard rate (`VATRate.NORMAL`,
 * DSFinV-K key 1), a shortfall as not taxable (`VATRate.NULL`, key 5). A zero difference is never posted.
 *
 * Mirrors `Shared.Core/Calculation/KassendifferenzPolicy.cs`, which the server applies to every posting
 * whatever a client sent; the web sends the same so the screen and the receipt agree. This is a documented
 * policy (DSFinV-K 2.4 Anhang C, p. 58, leaves the tax treatment of a difference to downstream systems),
 * recorded in `docs/verfahrensdokumentation/01-anwender/kassendifferenz.md`.
 */
export class KassendifferenzPolicy {
  static applies(type: BusinessCaseType): boolean {
    return type === BusinessCaseType.DifferenzSollIst;
  }

  /** The key for a difference whose signed money is `signedAmount` (positive = surplus, negative = shortfall). */
  static vatRateFor(signedAmount: number): VATRate {
    return signedAmount > 0 ? VATRate.NORMAL : VATRate.NULL;
  }
}
